
import {defineComponent} from "vue";
import DocumentationHomeAdmin from "@/components/documentation/DocumentationHomeAdmin.vue";
import {useUserStore} from "@/store/user/UserStore";
import DocumentationHomeManager from "@/components/documentation/DocumentationHomeManager.vue";

export default defineComponent({
  name: "DocumentationHome",
  components: {DocumentationHomeManager, DocumentationHomeAdmin},
  setup() {
    const userStore = useUserStore();
    const userState = userStore.getState();
    return {userState};
  },
});
